module.exports = require("/opt/build/repo/js/packages/flock-investor-fe/src/emotion-cache-props")